import { _processCalendarPricing, _isValidSOPQResult } from '../helpers'
import { buildFlexDatesPricingObj } from '../buildFlexDatesPricingObj'

export function _handleRetailFlexDatesResponse(
  res,
  trips,
  passengerUrl,
  requestObj,
  isOW
) {
  let response = []
  if (Array.isArray(res) && res.length > 0) {
    response = buildFlexDatesPricingObj(res, trips)
  }

  const result = {
    currentlyViewing: 0,
    calendarPricing: [],
  }

  if (response) {
    result.currentlyViewing = response.reduce((total, itin) => {
      return total + (itin.viewers && itin.viewers > 0 ? itin.viewers : 0)
    }, 0)

    const unfilteredCalendarPricing = response.map(itin => {
      return { ...itin, passengerUrl }
    }, [])

    result.calendarPricing = _processCalendarPricing(
      unfilteredCalendarPricing,
      isOW,
      requestObj
    )
  }

  return result
}

export function _handleSOPQElasticResponse(
  res = [],
  trips,
  passengerUrl,
  requestObj
) {
  let response = []
  if (Array.isArray(res) && res.length > 0) {
    response = buildFlexDatesPricingObj(res, trips)
  }

  /**
   * Flex Dates API return 'numstops: 0' for EXD itins as the default value
   * which on FE is used for non-stops, so delete the numStops before returning to UI.
   */
  return response.map(itin => {
    if (_isValidSOPQResult(itin, requestObj)) {
      delete itin.numStops
      return { ...itin, passengerUrl }
    }
    return {}
  })
}
